import React from 'react'

const Contact = () => {
    return (

        <div style={{ marginTop: "100px", marginBottom: "100px", justifyItems: "center" }}>
            <h2 className="text-center">Kontakt oss gjerne på <u>brukerfeilgroup@gmail.com</u></h2>
        </div>
    )
}

export default Contact
